import React from "react";

import { ButtonOutlined } from "../../../../components/common/Buttons/Button.Style";

import { ReactComponent as LibrasIcon } from "../../../../assets/images/icons/libras-icon.svg";

import * as S from "./LibrasAssistanceSection.style";

export const LibrasAssistanceSection = () => {
  return (
    <S.LibrasAssistanceSectionContainer>
      <S.LibrasAssistanceSectionContent className="container">
        <LibrasIcon width={140} height={150} />

        <S.LibrasAssistanceSectionBlock>
          <S.LibrasAssistanceSectionBlockHeader>
            <S.LibrasAssistanceSectionBlockTitle>
              Atendimento em Libras 24h
            </S.LibrasAssistanceSectionBlockTitle>

            <S.LibrasAssistanceSectionBlockDescription>
              Serviço para pessoas surdas ou com deficiência auditiva. Para
              receber atendimento por chamada de vídeo no site do nosso
              parceiro, <strong>clique no botão abaixo</strong>.
            </S.LibrasAssistanceSectionBlockDescription>
          </S.LibrasAssistanceSectionBlockHeader>

          <ButtonOutlined
            type="button"
            onClick={(e) => {
              e.preventDefault?.();
              document.getElementById("accessibility-button").click();
            }}
          >
            Iniciar atendimento{" "}
          </ButtonOutlined>
        </S.LibrasAssistanceSectionBlock>
      </S.LibrasAssistanceSectionContent>
    </S.LibrasAssistanceSectionContainer>
  );
};
